import Vue from "vue";
import {
  Button,
  Avatar,
  Input,
  Select,
  Option,
  InputNumber,
  Form,
  FormItem,
  Table,
  TableColumn,
  Tag,
  Checkbox,
  CheckboxGroup,
  Notification,
  Loading,
  Tooltip,
  MessageBox,
  DatePicker,
  Image,
  Radio,
  Collapse,
  CollapseItem,
  Carousel,
  CarouselItem,
  Link,
  Popover,
  Divider,
  Switch
} from "element-ui";

Vue.use(Button);
Vue.use(Avatar);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(Image);
Vue.use(Radio);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Link);
Vue.use(Popover);
Vue.use(Divider);
Vue.use(Switch);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$ELEMENT = { size: "mini" };
Vue.prototype.$notify = Notification;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
